import React, { useEffect, useState } from 'react';
import api from '../../services/api';

// V71 — İK portalı ortak yardımcıları: departman etiketi, TR tarih biçimi,
// yetkili görsel (personel fotoğrafı) ve yetkili dosya indirme.

export const DEPT_LABEL = { bilet: 'Bilet', otel: 'Otel', vize: 'Vize', muhasebe: 'Muhasebe', diger: 'Diğer' };

/** İK departman adı varsa o, yoksa MIO departman kodunun etiketi. */
export const deptLabel = (p) => (p && (p.hr_departman_ad || DEPT_LABEL[p.department] || p.department)) || '';

/** 'YYYY-MM-DD' / ISO → '12 Mar 2026' (tr-TR). Geçersizse girdi aynen döner. */
export const fmtDateTR = (s, withYear = true) => {
  if (!s) return '—';
  const d = new Date(String(s).slice(0, 10) + 'T00:00:00');
  if (isNaN(d.getTime())) return String(s);
  return d.toLocaleDateString('tr-TR', { day: 'numeric', month: 'short', ...(withYear ? { year: 'numeric' } : {}) });
};

/** ISO zaman damgası → '12 Mar 2026 14:05'. */
export const fmtDateTimeTR = (s) => {
  if (!s) return '—';
  const str = String(s).replace(' ', 'T');
  const d = new Date(/Z|[+-]\d\d:?\d\d$/.test(str) ? str : str + 'Z');
  if (isNaN(d.getTime())) return String(s);
  return d.toLocaleString('tr-TR', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
};

// <img src> Authorization başlığı taşımaz; /api/hr/... uçları token ister (401).
// Görsel axios ile (başlıkta token) blob olarak çekilir; oturum boyunca yol başına bir kez.
const imgCache = new Map(); // path -> Promise<objectURL|null>
const loadImg = (path) => {
  if (!imgCache.has(path)) {
    imgCache.set(path, api.get(path, { responseType: 'blob' })
      .then(r => (r.data && r.data.size ? URL.createObjectURL(r.data) : null))
      .catch(() => null));
  }
  return imgCache.get(path);
};

/** Yetkili görsel: yüklenemezse (ya da yüklenirken) `fallback` çizilir. `path` API köküne göredir. */
export function AuthImg({ path, className, style, alt = '', fallback = null }) {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    let alive = true;
    setSrc(null);
    if (path) loadImg(path).then(u => { if (alive) setSrc(u); });
    return () => { alive = false; };
  }, [path]);
  if (!src) return fallback;
  return <img src={src} className={className} style={style} alt={alt} onError={() => setSrc(null)} />;
}

/** Blob yanıtlı hatadan okunur mesaj (sunucu JSON { error } dönebilir). */
export const blobErrorText = async (e, fallback = 'İşlem başarısız.') => {
  const data = e && e.response && e.response.data;
  if (data instanceof Blob) {
    try { const j = JSON.parse(await data.text()); return j.error || fallback; } catch { return fallback; }
  }
  return (data && data.error) || (e && e.message) || fallback;
};

/** Yetkili dosya indirme (token başlıkta; yeni sekmede ham 401 JSON açılmaz). */
export const downloadAuthFile = async (path, filename) => {
  const r = await api.get(path, { responseType: 'blob' });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename || 'belge';
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1500);
};
